import React from 'react';
import {ComplaintForm} from './sub-view/complaint-form';
import {UserLayout} from 'components/layouts/user';

class SendComplaintContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout>
        <h1 className="user-header">Gửi khiếu nại</h1>
        <ComplaintForm/>
      </UserLayout>
    );
  }
}

export default SendComplaintContainer;



// WEBPACK FOOTER //
// ./components/users/SendComplaintContainer.jsx